export const isUrlVariable = (urlSlice: string): boolean => {
  if (!urlSlice) return false;

  return urlSlice.startsWith(':');
};

export const isObjectEmpty = (object: any): boolean => {
  return Object.entries(object ?? {}).length === 0;
};

export const buildApiUrl = (url: string, replacements?: Record<string, string>): string => {
  if (!url) return '';

  if (!replacements || isObjectEmpty(replacements)) return url;

  const urlSlices = url.split('/');
  const parsedUrlSlices = urlSlices.map(slice => {
    if (isUrlVariable(slice)) {
      const replacement = slice.replace(':', '');

      return replacements[replacement] ?? slice;
    }

    return slice;
  });

  return parsedUrlSlices.join('/');
};
